import React, { Fragment, useState } from 'react';

import DefaultImg from '../../../src/images/entrypage/header-background.png';
import Logo from '../../../src/images/entrypage/logo-main.svg';
import BasicModal from "../../SharedComponents/BasicModal";
import SvgIcon from "../../SharedComponents/Icons";
import FullScreenGallery from "./FullScreenGallery";

import './index.sass';


const Gallery = ({ labelTag, photos, showLabel, vimeoId }) => {

  const [isFullscreen, setIsFullscreen] = useState(false);
  const [videoIsOpen, setVideoIsOpen] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const photosCount = (photos && photos.length) || 0;
  const photosPresent = photosCount !== 0;

  const handleOpenFullscreen = (index) => {
    setActiveSlide(index);
    setIsFullscreen(true);
  };

  const label = showLabel && labelTag && labelTag.name;

  const banner =
    <div style={{ padding: '24px', background: '#FFFCF3', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
      <img alt="logo"
           className="lazyload"
           data-expand="100"
           data-sizes="auto"
           data-src={Logo}
           style={{ width: '100%' }} />
    </div>;

  // const showPhotosButton = photosPresent && (photosCount > 5 || )


  return (
    <div className="gallery-wrapper">

      <BasicModal
        mobileFullWidth={true}
        modalClass="video"
        handleClose={() => setVideoIsOpen(false)}
        showModal={videoIsOpen}>
        <div className="video__container">
          <iframe
            allow={"autoplay; fullscreen; picture-in-picture"}
            allowFullScreen
            frameBorder={0}
            src={`https://player.vimeo.com/video/${vimeoId}?h=bc9e80752a&color=f5aea0`}
          />
        </div>
      </BasicModal>

      <div className="gallery-wrapper__assets-container">
        <div className="row">
          <div className="col-12 col-lg-6 gallery-wrapper__mobile-main">
            { photosPresent
              ?
                <img alt={photos[0].alt}
                     className="gallery-wrapper__img lazyload"
                     data-expand="100"
                     data-sizes="auto"
                     data-src={photos[0].original}
                     onClick={() => handleOpenFullscreen(0)}
                />
              :
                <img alt="Default"
                     className="gallery-wrapper__img lazyload"
                     data-expand="100"
                     data-sizes="auto"
                     data-src={DefaultImg}
                />
            }

            { !photosPresent &&
              <Fragment>
                <div className="gallery-wrapper__img-default-cover" />
                <div className="gallery-wrapper__img-default-label">Billede på vej</div>
              </Fragment>
            }

            { label &&
              <div className="gallery-wrapper__label">
                { label }
              </div>
            }
          </div>
          <div className="col-lg-6 gallery-wrapper__mobile-hidden">
            <div className="row">
              { (!photosPresent || photosCount < 5) &&
                <div className="col-lg-12">
                  { photosPresent && photosCount >= 2
                    ? <img alt={photos[1].alt}
                           className="gallery-wrapper__img lazyload"
                           data-expand="100"
                           data-sizes="auto"
                           data-src={photos[1].original}
                           onClick={() => handleOpenFullscreen(1)}
                      />
                    : banner
                  }
                </div>
              }

              { photosCount >= 5 && photos.map((photo, index) =>
                index > 0 && index < 5 &&
                <div className="col-lg-6" key={`gallery-img${photo.id}`}>
                  <img alt={photo.alt}
                       className="gallery-wrapper__img lazyload"
                       data-expand="100"
                       data-sizes="auto"
                       data-src={photo.original}
                       onClick={() => handleOpenFullscreen(index)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      { isFullscreen &&
        <FullScreenGallery
          data={photos}
          handleClose={() => setIsFullscreen(false)}
          startIndex={activeSlide}
        />
      }

      <div className="gallery-wrapper__buttons-wrapper">
        { photosPresent &&
          <div className="gallery-wrapper__button" onClick={() => handleOpenFullscreen(0)}>
            <SvgIcon name="camera" size={20} />
            Se fotos
          </div>
        }

        { vimeoId &&
          <div className="gallery-wrapper__button" onClick={() => setVideoIsOpen(true)}>
            <SvgIcon name="video" size={20} />
            Se video
          </div>
        }
      </div>

    </div>
  )
}

export default Gallery;
